import { useState } from 'react';
import { isEmpty } from '@intelligence/v3/utils/common';

// id列表类型
export type IPrimaryKeys = string[] | number[];

export default function useLazyData(props: {
  fetchDetailsData: (params?: IPrimaryKeys | null) => IBaseResponse<unknown>;
}) {
  const { fetchDetailsData } = props;

  // 是否懒加载数据中
  const [loading, setLoading] = useState(true);
  // 懒加载数据
  const [data, setData] = useState<IRecord<IRecord>>({});

  /**
   * @description 刷新懒加载的数据
   * @param ids id列表
   */
  const refresh = async (ids?: IPrimaryKeys | null) => {
    if (isEmpty(ids)) {
      setLoading(false);
      setData({});
      return {};
    }

    let newData: IRecord<IRecord> = {};

    try {
      setLoading(true);
      const res = await fetchDetailsData(ids);
      newData = (res?.data as IRecord<IRecord>) || {};
    } catch (error) {
      console.error(error);
      newData = {};
    } finally {
      setLoading(false);
      setData(newData);
    }

    return newData;
  };

  return { loading, data, setData, refresh };
}
